var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM12.017 10.93a7.216 7.216 0 0 0-3.582-1.795 7.63 7.63 0 0 0-4.07.335c-1.29.479-2.394 1.297-3.171 2.351A6.003 6.003 0 0 0 0 15.387c0 .163.07.319.197.434.125.114.296.179.474.179H13.33a.705.705 0 0 0 .474-.18.587.587 0 0 0 .197-.433 5.674 5.674 0 0 0-.325-1.913 6.258 6.258 0 0 0-1.658-2.545ZM15 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM14.693 9A6.127 6.127 0 0 0 12 9.622c.153.114.309.226.454.35.963.823 1.679 1.824 2.088 2.92.14.362.244.732.31 1.108h4.44a.787.787 0 0 0 .5-.172.543.543 0 0 0 .208-.416c-.002-1.17-.561-2.291-1.556-3.118C17.449 9.466 16.1 9 14.694 9Z",
    fill: "#979BA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.c984c2c99a3da8dd5589106e6e13ce15.svg";
export { ForwardRef as ReactComponent };